import * as angular from 'angular';
import * as _ from 'lodash';
import ManufacturerResource from '../models/manufacturer-resource';
import ResourceService from './resource.service';

export default class ManufacturerService extends ResourceService<ManufacturerResource> {
  constructor(BaseResource) {
    super(BaseResource, ManufacturerResource);
  }
}

angular
  .module('ciApp.services')
  .service('ManufacturerService', ['BackendService', ManufacturerService]);



// WEBPACK FOOTER //
// ./common/services/manufacturer.service.ts